import * as React from "react";
import { CardWrap, CardWrapWithMobile, StarHolder } from "./styles";
export const CommentStarForWeb = (props) => {
    return (React.createElement(CardWrap, { key: "commentStar" },
        React.createElement(React.Fragment, null, RenderStart(Object.assign(Object.assign({}, props), { width: "10px" }))),
        props.children));
};
export const CommentStarForM = (props) => {
    return (React.createElement(CardWrapWithMobile, { key: "commentStar" },
        React.createElement(React.Fragment, null, RenderStart(Object.assign(Object.assign({}, props), { width: "0.625rem" }))),
        props.children));
};
export function RenderStart(props) {
    const { rateScore, width } = props;
    return [1, 2, 3, 4, 5].map((i, idx) => {
        if (rateScore >= i) {
            return (React.createElement(StarHolder, { key: idx, className: "iconfont icon-ic_star", width: width }));
        }
        if (Math.ceil(rateScore) === i) {
            const percentWidth = (rateScore - i + 1).toFixed(2);
            return (React.createElement(StarHolder, { key: idx, width: width, className: "iconfont icon-ic_star_unselect" },
                React.createElement("span", { className: "iconfont icon-ic_star", style: { width: `${+percentWidth * 90}%` } })));
        }
        return (React.createElement(StarHolder, { key: idx, width: width, className: "iconfont icon-ic_star_unselect" }));
    });
}
